// slice to 30 characters to avoid exceeding the max length field in the contract
export const trimCategory = (category: string) => {
  return category.slice(0, 30)
}

const validateCategoryUniqueness = (...values: string[]) => {
  const trimmedCategories = new Set<string>()
  for (const category of values) {
    const trimmed = trimCategory(category)
    if (trimmedCategories.has(trimmed)) {
      throw new Error(`Duplicate trimmed category found: ${trimmed}`)
    }
    trimmedCategories.add(trimmed)
  }
  return values
}

export const CATEGORIES = validateCategoryUniqueness(
  'ENTERTAINMENT',
  'FOOD_AND_DRINK',
  'GENERAL_MERCHANDISE',
  'HOME_IMPROVEMENT',
  'MEDICAL',
  'PERSONAL_CARE',
  'GENERAL_SERVICES',
  'GOVERNMENT_AND_NON_PROFIT',
  'TRANSPORTATION',
  'TRAVEL',
  'RENT_AND_UTILITIES',
)

export const SUBCATEGORIES = validateCategoryUniqueness(
  'ENTERTAINMENT_CASINOS_AND_GAMBLING',
  'ENTERTAINMENT_MUSIC_AND_AUDIO',
  'ENTERTAINMENT_SPORTING_EVENTS_AMUSEMENT_PARKS_AND_MUSEUMS',
  'ENTERTAINMENT_TV_AND_MOVIES',
  'ENTERTAINMENT_VIDEO_GAMES',
  'ENTERTAINMENT_OTHER_ENTERTAINMENT',
  'FOOD_AND_DRINK_BEER_WINE_AND_LIQUOR',
  'FOOD_AND_DRINK_COFFEE',
  'FOOD_AND_DRINK_FAST_FOOD',
  'FOOD_AND_DRINK_GROCERIES',
  'FOOD_AND_DRINK_RESTAURANT',
  'FOOD_AND_DRINK_VENDING_MACHINES',
  'FOOD_AND_DRINK_OTHER_FOOD_AND_DRINK',
  'GENERAL_MERCHANDISE_BOOKSTORES_AND_NEWSSTANDS',
  'GENERAL_MERCHANDISE_CLOTHING_AND_ACCESSORIES',
  'GENERAL_MERCHANDISE_CONVENIENCE_STORES',
  'GENERAL_MERCHANDISE_DEPARTMENT_STORES',
  'GENERAL_MERCHANDISE_DISCOUNT_STORES',
  'GENERAL_MERCHANDISE_ELECTRONICS',
  'GENERAL_MERCHANDISE_GIFTS_AND_NOVELTIES',
  'GENERAL_MERCHANDISE_OFFICE_SUPPLIES',
  'GENERAL_MERCHANDISE_ONLINE_MARKETPLACES',
  'GENERAL_MERCHANDISE_PET_SUPPLIES',
  'GENERAL_MERCHANDISE_SPORTING_GOODS',
  'GENERAL_MERCHANDISE_SUPERSTORES',
  'GENERAL_MERCHANDISE_TOBACCO_AND_VAPE',
  'GENERAL_MERCHANDISE_OTHER_GENERAL_MERCHANDISE',
  'HOME_IMPROVEMENT_FURNITURE',
  'HOME_IMPROVEMENT_HARDWARE',
  'HOME_IMPROVEMENT_REPAIR_AND_MAINTENANCE',
  'HOME_IMPROVEMENT_SECURITY',
  'HOME_IMPROVEMENT_OTHER_HOME_IMPROVEMENT',
  'MEDICAL_EYE_CARE',
  'MEDICAL_PHARMACIES_AND_SUPPLEMENTS',
  'MEDICAL_VETERINARY_SERVICES',
  'PERSONAL_CARE_GYMS_AND_FITNESS_CENTERS',
  'PERSONAL_CARE_HAIR_AND_BEAUTY',
)
